import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { UserManagementUsersEditTemplate } from '../index';
import styles from './UserManagementUsersEditRolesTemplate.module.css';
import cn from 'classnames';
import { UserManagementUsersRoles } from '../../organisms';
import { Button } from '../../atoms';
import { UserRoleDto } from '../../../store/contextAPI/role/dto/response/user-role.dto';

export interface UserManagementUsersEditRolesTemplateProps {
  data: UserRoleDto[];
  handleDeleteRole: (id: string) => void;
  setShowModal: (show: boolean) => void;
}

const UserManagementUsersEditRolesTemplate: FC<
  UserManagementUsersEditRolesTemplateProps
> = ({ data, handleDeleteRole, setShowModal }) => {
  return (
    <BaseTemplate>
      <Container>
        <UserManagementUsersEditTemplate>
          <div className={cn(styles.addRoleButtonWrapper)}>
            <Button
              onClick={() => setShowModal(true)}
              className={cn(styles.addRoleButton)}
              variant={'light'}
            >
              Add Role
            </Button>
          </div>
          <div className={cn(styles.formWrapper)}>
            <UserManagementUsersRoles
              data={data}
              handleDeleteRole={handleDeleteRole}
            />
          </div>
        </UserManagementUsersEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default UserManagementUsersEditRolesTemplate;
